(function($) {

$(document).ready(function(){
	$('#newsletter-trigger').on('click',function(){
		$('#newsletter-signup').fadeIn();
	});

	// newsletter submission
	$('.modal__box__left .lm-btn').on('click',function(){
		$('#newsletter-signup .form').hide();
		$('#newsletter-signup .success').slideDown();
	});
});

})( jQuery );  